import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_LT.json';
import exercises from './FITNESS_EXERCISES_LT.json';
import recipes from './FITNESS_RECIPES_LT.json';

export const FITNESS_DATA_LT: ServiceData = {
  articles,
  exercises,
  recipes,
};
